export default "__VITE_ASSET__X_$l77wg__"